import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { useFpCampaignProductsStore } from '@cart-services/hooks/useFpCampaignProductsStore'
import type { ProjectCode } from '@constants'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useHistory } from 'react-router-dom-v5'

export const useCampaignBrands = () => {
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: campaign } = useApiCampaignActivityInfo(campaignCodeFromUrl)
  const { projectCode, setProjectCode } = useFpCampaignProductsStore()
  const history = useHistory()

  const brands = campaign?.brand_codes_info.map(brand => ({
    ...brand,
    brand_image: campaign?.icons?.find(icon => icon.project_code === brand.project_code)?.icon_url ?? brand.brand_image,
  })) ?? []

  const switchBrand = (nextProjectCode: ProjectCode) => {
    setProjectCode(nextProjectCode)
    history.push(`/campaigns/${campaignCodeFromUrl}`)
  }

  return { brands, projectCode, switchBrand }
}
